
import { featuredPlaylists } from '../../../mocks/musicData';

interface FeaturedPlaylistsProps {
  onTrackSelect?: (track: any, trackList?: any[]) => void;
}

export default function FeaturedPlaylists({ onTrackSelect }: FeaturedPlaylistsProps) {
  const handlePlayPlaylist = (playlist: any) => {
    // Play the first track of the playlist
    if (playlist.tracks && playlist.tracks.length > 0 && onTrackSelect) {
      onTrackSelect(playlist.tracks[0], playlist.tracks);
    }
  };

  const handleViewAll = () => {
    window.REACT_APP_NAVIGATE('/playlists');
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Featured Playlists</h2>
            <p className="text-gray-600">Curated collections for every mood</p>
          </div>
          <button 
            onClick={handleViewAll}
            className="text-purple-600 hover:text-purple-700 font-medium cursor-pointer whitespace-nowrap"
          >
            View All
          </button>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
          {featuredPlaylists.map((playlist) => (
            <div 
              key={playlist.id} 
              className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer group"
            >
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src={playlist.imageUrl}
                  alt={playlist.title}
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePlayPlaylist(playlist);
                    }}
                    className="w-12 h-12 bg-purple-600 hover:bg-purple-700 text-white rounded-full opacity-0 group-hover:opacity-100 transform scale-75 group-hover:scale-100 transition-all duration-300 flex items-center justify-center cursor-pointer"
                  >
                    <i className="ri-play-fill text-lg"></i>
                  </button>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-gray-900 mb-1 truncate">{playlist.title}</h3>
                <p className="text-sm text-gray-600 mb-2 line-clamp-2">{playlist.description}</p>
                <div className="flex items-center justify-between text-xs text-gray-500">
                  <span>{playlist.trackCount} tracks</span>
                  <span>{playlist.plays} plays</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
